<template>
  <div>
    <div class="ipt">
      <div
        @click.stop="isHot = !isHot"
        class="down"
        :style="{ borderBottomLeftRadius: isHot ? '0' : '10' + 'px' }"
      >
        <span style="marginleft: 18px">{{ kwd }}</span>
        <Icon class="iconDown" v-if="isHot" type="ios-arrow-down" />
        <Icon class="iconDown" v-else type="ios-arrow-up" />
        <ul v-if="isHot">
          <li
            @click="select(item.title, item.searchType, index)"
            v-for="(item, index) in nav"
            :key="item.id"
            :class="{ act: index + 1 == indexs }"
          >
            {{ item.title }}
          </li>
        </ul>
      </div>
      <div @click="isHot = false" class="input">
        <input
          v-model="inpText"
          @keydown.enter="toDetai"
          placeholder="请输入关键字，如科技、化学、癔症"
          type="text"
        />
        <Icon @click="seek" class="icon" type="ios-search" />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Input",
  components: {},
  props: ["InputAndActiveType"],
  data() {
    return {
      isHot: false,
      kwd: "",
      kwdId: "",
      inpText: this.$route.query.paramStr ? this.$route.query.paramStr : "",
      nav: [],
      indexs: sessionStorage.getItem("indexs"),
    };
  },
  computed: {},
  watch: {
    InputAndActiveType() {
      this.downList();
    },
    kwdId() {
      this.homeReset();
    },
  },
  created() {
    this.downList();
    if (this.$route.query.articleType) {
      this.kwdId = this.$route.query.searchType;
    }
  },
  mounted() {
    this.$bus.$on("isHot", (f) => {
      this.isHot = f;
    });
  },
  methods: {
    // 首页跳过来的,根据标识进行显示
    homeReset() {
      if (this.$route.query.articleType == 999) {
        // 如果是全部
        switch (this.$route.query.searchType) {
          case "title":
            this.kwd = "标题";
            break;
          case "othorAuthor":
            this.kwd = "作者";
            break;
          case "keyword":
            this.kwd = "关键字";
            break;
          case "artSummary":
            this.kwd = "摘要";
            break;
        }
      } else if (this.$route.query.articleType == 0) {
        // 如果是论文
        switch (this.$route.query.searchType) {
          case "title":
            this.kwd = "标题";
            break;
          case "othorAuthor":
            this.kwd = "作者";
            break;
          case "keyword":
            this.kwd = "关键字";
            break;
          case "artSummary":
            this.kwd = "摘要";
            break;
          case "periodical":
            this.kwd = "期刊名称";
            break;
        }
      } else if (this.$route.query.articleType == 5) {
        // 如果是资讯
        switch (this.$route.query.searchType) {
          case "title":
            this.kwd = "标题";
            break;
          case "keyword":
            this.kwd = "关键字";
            break;
          case "artSummary":
            this.kwd = "摘要";
            break;
          case "othorAuthor":
            this.kwd = "作者";
            break;
          default:
            break;
        }
      } else if (this.$route.query.articleType == 2) {
        // 如果是专著
        switch (this.$route.query.searchType) {
          case "title":
            this.kwd = "标题";
            break;
          case "othorAuthor":
            this.kwd = "作者";
            break;
          case "artSummary":
            this.kwd = "摘要";
            break;
          case "periodical":
            this.kwd = "出版单位";
            break;

          default:
            break;
        }
      } else if (this.$route.query.articleType == 8) {
        // 如果是会议
        switch (this.$route.query.searchType) {
          case "title":
            this.kwd = "会议名称";
            break;
          case "orgHost":
            this.kwd = "主办单位";
            break;
          case "orgUndertake":
            this.kwd = "承办单位";
            break;
          case "orgAssist":
            this.kwd = "协办单位";
            break;
          case "keyword":
            this.kwd = "标签";
            break;
          case "artSummary":
            this.kwd = "摘要";
            break;
        }
      } else if (this.$route.query.articleType == 1) {
        // 如果是学者
        switch (this.$route.query.searchType) {
          case "name":
            this.kwd = "学者姓名";
            break;
          case "currentWorkUnit":
            this.kwd = "任职机构";
            break;
        }
      } else if (this.$route.query.articleType == 3) {
        // 如果是期刊
        switch (this.$route.query.searchType) {
          case "name":
            this.kwd = "期刊姓名";
            break;
          case "dominantAgency":
            this.kwd = "主管单位";
            break;
          case "organizerUnit":
            this.kwd = "主办单位";
            break;
          case "publishUnit":
            this.kwd = "出版单位";
            break;
          case "cn":
            this.kwd = "CN";
            break;
          case "issn":
            this.kwd = "ISSN";
            break;
        }
      } else if (this.$route.query.articleType == 4) {
        // 如果是机构
        switch (this.$route.query.searchType) {
          case "name":
            this.kwd = "机构名称";
            break;
          case "dominantAgency":
            this.kwd = "主管单位";
            break;
        }
      } else if (this.$route.query.articleType == 22) {
        // 如果是名录
        if (this.$route.query.searchType == "name") {
          this.kwd = "名录名称";
        }
      } else if (this.$route.query.articleType == 9) {
        // 如果是名录
        switch (this.$route.query.searchType) {
          case "title":
            this.kwd = "课程名称";
            break;
          case "publisher":
            this.kwd = "发布人";
            break;
        }
      }
    },
    // 搜索下拉内容切换
    downList() {
      this.nav = [];
      this.isHot = false;
      switch (this.InputAndActiveType) {
        case 999:
          const obj1 = [
            { id: 1, title: "标题", searchType: "title" },
            { id: 2, title: "作者", searchType: "othorAuthor" },
            { id: 3, title: "关键词", searchType: "keyword" },
            { id: 4, title: "摘要", searchType: "artSummary" },
          ];
          this.remediation(obj1);
          this.nav.push(...obj1);
          break;
        case 0:
          const obj2 = [
            { id: 1, title: "标题", searchType: "title" },
            { id: 2, title: "作者", searchType: "othorAuthor" },
            { id: 3, title: "关键词", searchType: "keyword" },
            { id: 4, title: "摘要", searchType: "artSummary" },
            { id: 5, title: "期刊名称", searchType: "periodical" },
          ];
          this.remediation(obj2);
          this.nav.push(...obj2);
          break;
        case 5:
          const obj3 = [
            { id: 1, title: "标题", searchType: "title" },
            { id: 2, title: "关键词", searchType: "keyword" },
            { id: 3, title: "摘要", searchType: "artSummary" },
            { id: 4, title: "作者", searchType: "othorAuthor" },
          ];
          this.remediation(obj3);
          this.nav.push(...obj3);
          break;
        case 2:
          const obj4 = [
            { id: 1, title: "标题", searchType: "title" },
            { id: 2, title: "作者", searchType: "othorAuthor" },
            { id: 3, title: "摘要", searchType: "artSummary" },
            { id: 4, title: "出版单位", searchType: "periodical" },
          ];
          this.remediation(obj4);
          this.nav.push(...obj4);
          break;
        case 8:
          const obj5 = [
            { id: 1, title: "会议名称", searchType: "title" },
            { id: 2, title: "主办单位", searchType: "orgHost" },
            { id: 3, title: "承办单位", searchType: "orgUndertake" },
            { id: 4, title: "协办单位", searchType: "orgAssist" },
            { id: 5, title: "标签", searchType: "keyword" },
            { id: 6, title: "摘要", searchType: "artSummary" },
          ];
          this.remediation(obj5);
          this.nav.push(...obj5);
          break;
        case 1:
          const obj6 = [
            { id: 1, title: "学者姓名", searchType: "name" },
            { id: 2, title: "任职机构", searchType: "currentWorkUnit" },
          ];
          this.remediation(obj6);
          this.nav.push(...obj6);
          break;
        case 3:
          const obj7 = [
            { id: 1, title: "期刊名称", searchType: "name" },
            { id: 2, title: "主管单位", searchType: "dominantAgency" },
            { id: 3, title: "主办单位", searchType: "organizerUnit" },
            { id: 4, title: "出版单位", searchType: "publishUnit" },
            { id: 5, title: "CN", searchType: "cn" },
            { id: 6, title: "ISSN", searchType: "issn" },
          ];
          this.remediation(obj7);
          this.nav.push(...obj7);
          break;
        case 4:
          const obj8 = [
            { id: 1, title: "机构名称", searchType: "name" },
            { id: 2, title: "主管单位", searchType: "dominantAgency" },
          ];
          this.remediation(obj8);
          this.nav.push(...obj8);
          break;
        case 22:
          const obj22 = [{ id: 1, title: "名录名称", searchType: "name" }];
          this.remediation(obj22);
          this.nav.push(...obj22);
          break;
        case 9:
          const obj9 = [
            { id: 1, title: "课程名称", searchType: "title" },
            { id: 2, title: "发布人", searchType: "publisher" },
          ];
          this.remediation(obj9);
          this.nav.push(...obj9);
          break;
      }
    },
    // 放大镜
    seek() {
      this.toDetai();
    },
    // 跳转搜索
    toDetai() {
      if (this.inpText == "") return;
      // console.log(this.inpText);
      // let str = '100%水果苹果！'
      // let a = encodeURI(encodeURI(str));
      // console.log(a);
      // console.log(decodeURIComponent(decodeURI(this.inpText)));
      this.$router.push({
        path: "/search",
        query: {
          paramStr: this.inpText,
          searchType: this.kwdId,
          title: this.kwd,
        },
      });
    },
    // 下拉框选择
    select(title, searchType, index) {
      sessionStorage.removeItem("searchType"); // 该标识在切换栏目类型是被添加,在切换下拉列表时被清除
      this.kwd = title;
      this.kwdId = searchType;
      this.toDetai();
      sessionStorage.setItem("indexs", index + 1); // 调用toDetai会使data中数据重置,需要存储到sessionStorage中
    },
    // 因为下拉框选择会重新走一遍该组件,会导致kwd和kwdId显示异常,所以用该方法限制
    remediation(obj) {
      if (this.$route.query.title && !sessionStorage.getItem("searchType")) {
        this.kwd = this.$route.query.title;
        this.kwdId = this.$route.query.searchType;
      } else {
        this.kwd = obj[0].title;
        this.kwdId = obj[0].searchType;
      }
    },
  },
};
</script>

<style scoped lang="scss">
.ipt {
  width: 100%;
  display: flex;
  justify-content: center;
  margin-bottom: 50px;
  & .input {
    width: 80%;
    height: 50px;
    background: #ffffff;
    border: 1px solid #dcdcdc;
    border-left: none;
    border-top-right-radius: 10px;
    border-bottom-right-radius: 10px;
    & .icon {
      position: relative;
      top: -28px;
      left: 911px;
      font-size: 25px;
      cursor: pointer;
    }
    & input {
      width: 100%;
      height: 70%;
      margin-top: 7px;
      border: none;
      border-left: 1px solid #dcdcdc;
      padding: 0 55px 0 20px;
    }
  }
  & .down {
    width: 120px;
    padding: 0 10px;
    height: 50px;
    border: 1px solid #dcdcdc;
    border-right: none;
    line-height: 50px;
    text-align: left;
    padding-left: 20px;
    cursor: pointer;
    border-top-left-radius: 10px;
    & .iconDown {
      margin-left: 10px;
    }
    & ul {
      background: #ffffff;
      position: relative;
      top: -2px;
      left: -21px;
      width: 120px;
      z-index: 99;
      border: 1px solid #dcdcdc;
      border-top: none;
      text-align: left;
      & li {
        width: 100%;
        border-top: 1px solid #dcdcdc;
        height: 40px;
        line-height: 40px;
        padding-left: 20px;
      }
      & li:hover {
        background: #b3b3b3;
        color: #ffffff;
      }
      & .act {
        background: #8d8fff;
        color: #ffffff;
      }
      & :nth-child(1) {
        border: none;
      }
    }
  }
}
</style>
